import React from 'react';
import { 
  Crown, 
  Gem, 
  Sparkles, 
  Diamond, 
  Heart, 
  Flower2,
  ArrowRight,
  Star,
  Shield
} from 'lucide-react';

const CraftsmanshipSection = () => {
  const categories = [
    {
      name: "Gold Bridal Set",
      description: "Exquisite bridal collections for your special day",
      items: 48,
      image: "https://tse2.mm.bing.net/th/id/OIP.M4QgY6PekelgYAgf323QVgHaHa?w=696&h=696&rs=1&pid=ImgDetMain&o=7&rm=3"
    },
    {
      name: "Gold Jewellery",
      description: "Timeless gold pieces for every occasion",
      items: 156,
      image: "https://i.pinimg.com/originals/9e/d2/2d/9ed22d3eee7c650c94153f096e513e96.jpg"
    },
    {
      name: "Diamond Necklace Set",
      description: "Luxurious diamond necklaces that dazzle",
      items: 32,
      image: "https://5.imimg.com/data5/ANDROID/Default/2021/1/MI/WL/KT/86636070/product-jpeg-500x500.jpg"
    },
    {
      name: "Diamond Jewellery",
      description: "Premium diamond collections for elegance",
      items: 124,
      image: "https://tse3.mm.bing.net/th/id/OIP.vfHCvyQkzHZp52224R70mgHaHa?rs=1&pid=ImgDetMain&o=7&rm=3"
    },
    {
      name: "Gold Rings & Bangles",
      description: "Beautiful rings and bangles for every style",
      items: 89,
      image: "https://tse2.mm.bing.net/th/id/OIP.jT9MNkkW4VA-4wMI2A9JIQHaHJ?rs=1&pid=ImgDetMain&o=7&rm=3"
    },
    {
      name: "Gold Mangalsutra",
      description: "Sacred mangalsutras symbolizing eternal love",
      items: 28,
      image: "https://i.pinimg.com/originals/f2/57/72/f25772d14bbdc296c137f897c1472eb9.jpg"
    },
    {
      name: "Rose Gold Jewellery",
      description: "Trendy rose gold pieces for modern women",
      items: 67,
      image: "https://i.etsystatic.com/8728158/r/il/dd5ad9/1711528877/il_800x800.1711528877_4k4x.jpg"
    },
    {
      name: "Polki Diamonds",
      description: "Authentic Polki diamond jewellery with heritage",
      items: 42,
      image: "https://www.themakeupartist.in/wp-content/uploads/2023/05/Polki-Jewellery.jpg"
    }
  ];
  return (
    <section className="py-20 bg-gradient-to-b from-white via-gray-50 to-white relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-72 h-72 bg-amber-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-72 h-72 bg-blue-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse delay-1000"></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-100 to-yellow-100 px-5 py-2 rounded-full mb-5">
            <Crown className="w-4 h-4 text-amber-600" />
            <span className="text-sm font-semibold text-amber-700 uppercase tracking-wide">Our Expertise</span>
          </div>
          
          <h2 className="text-2xl md:text-2xl lg:text-6xl font-bold mb-4">
            <span className="bg-gradient-to-r from-amber-600 to-yellow-600 bg-clip-text text-transparent">
              Featured Collections
            </span>
          </h2>
          
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Discover the artistry and passion behind every creation
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {categories.map((category, index) => (
            <div
              key={index}
              className="group relative rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 cursor-pointer"
            >
              <div className="relative h-80 w-full overflow-hidden">
                <img 
                  src={category.image} 
                  alt={category.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
              </div>
              <div className="p-5 bg-white">
                <h3 className="text-base font-bold text-gray-800 mb-2 group-hover:text-amber-600 transition-colors duration-300">
                  {category.name}
                </h3>
                <p className="text-gray-500 text-xs mb-3">
                  {category.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-amber-600 font-semibold text-xs flex items-center gap-1">
                    {category.items}+ Designs
                  </span>
                  <div className="flex items-center gap-0.5">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="w-3 h-3 fill-amber-400 text-amber-400" />
                    ))}
                  </div>
                </div>
                <div className="mt-3">
                  <span className="text-amber-600 font-semibold text-xs group-hover:gap-2 transition-all duration-300 flex items-center gap-1">
                    View Collection <ArrowRight className="w-3 h-3" />
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-16 bg-gradient-to-r from-blue-900 to-blue-800 rounded-2xl p-8 text-center relative overflow-hidden">
          <div className="absolute inset-0 bg-white/10 transform -skew-x-12"></div>
          <div className="relative z-10">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-3">
              Ready to Find Your Perfect Piece?
            </h3>
            <p className="text-white/90 mb-6">
              Explore our complete collection of handcrafted jewellery
            </p>
            <button className="bg-white text-amber-600 px-8 py-3 rounded-full font-semibold hover:shadow-xl transition-all duration-300 hover:scale-105">
              Shop All Collections
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CraftsmanshipSection;